import React from 'react'

export default function CuriositiesAds() {
    return (
        <div id="amzn-assoc-ad-04e61c43-d503-40e5-8fa2-1395ac127dcb"></div>
    )
}

